import { useEffect } from "react"
import { useNavigate, useOutletContext, useParams } from "react-router-dom"

import type { Tower } from "types/towers.types"

import { BodyContainer } from "widgets/styled/containers"
import TowerDashboard from "widgets/towers/TowerDashboard"
import { getTowerAmbientTabPlotDefs } from "helpers/config/dashboards"
import { isTowerHealthEnabled } from "helpers/utils/towerHealth"

const config = {
  type: "towerAmbientTab" as const,
  plotDefs: getTowerAmbientTabPlotDefs(),
}

const TowerAmbient = () => {
  const navigate = useNavigate()
  const { orgId, id } = useParams()
  const { tower, towerFetching } = useOutletContext<{
    tower: Tower
    towerFetching: boolean
  }>()

  const towerHealthEnabled = isTowerHealthEnabled(tower)

  useEffect(() => {
    if (tower && !towerHealthEnabled) {
      navigate(`/orgs/${orgId}/towers/${id}`, { replace: true })
    }
  }, [tower, towerHealthEnabled, navigate, orgId, id])

  if (!towerHealthEnabled) {
    return null
  }

  return (
    <BodyContainer disableGutters maxWidth="xl">
      <TowerDashboard tower={tower} towerFetching={towerFetching} config={config} />
    </BodyContainer>
  )
}

export default TowerAmbient
